// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"224":"446ba0a4","301":"fc520d9b"}[chunkId] + ".css";
};